/** https://github.com/kotarok/jQuery.zip2addr*/
$.fn.zip2addr = function (b) {
	var d = $.fn.zip2addr.cache,
		k = function (a, b) {
			$.getJSON("https://www.google.com/transliterate?langpair=ja-Hira|ja&jsonp=?", {
				text: a
			}, function (a) {
				RegExp("(\u6771\u4eac\u90fd|\u9053|\u5e9c|\u770c)").test(a[0][1][0]) && b(a[0][1][0].replace(RegExp("(.*?(\u6771\u4eac\u90fd|\u9053|\u5e9c|\u770c))(.+)"), function (a, b, c, h) {
					return [b, h]
				}))
			})
		},
		f = function () {
			return "object" == typeof b && b.pref ? function (a) {
				(a = a.split(",")) ? RegExp(a[1]).test($(b.addr).val()) || ($(b.pref).val(a[0]), $(b.addr).val(a[1])):
					RegExp(a[1]).test($(b.addr).val()) || $(b.pref).add(b.addr).val("")
			} : function (a) {
				a = a.replace(",", "");
				var c = b.addr || b;
				a ? RegExp(a).test($(c).val()) || $(c).val(a) : RegExp(a).test($(c).val()) || $(c).val("")
			}
		}(),
		e = function () {
			var a = /[\uFF01-\uFF5E]/g,
				b = function (a) {
					return String.fromCharCode(a.charCodeAt() - 65248)
				};
			return function (c) {
				return c.replace(a, b)
			}
		}(),
		g = function (a) {
			var b = e(a).replace(/\D/g, "");
			7 == b.length && (void 0 == d[b] ? k(b.replace(/(\d\d\d)(\d\d\d\d)/, "$1-$2"), function (a) {
				d[b] = a;
				f(a)
			}) : f(d[b]))
		};
	this.each(function () {
		var a =
			$(this);
		"object" == typeof b && b.zip2 ? a.add($(b.zip2)).bind("keyup.zip2addr change.zip2addr", function () {
			g(a.val() + "" + $(b.zip2).val())
		}).bind("blur.zip2addr", function () {
			$(this).val(function () {
				return e($(this).val())
			})
		}) : a.bind("keyup.zip2addr change.zip2addr", function () {
			g(a.val())
		}).bind("blur.zip2addr", function () {
			$(this).val(function () {
				return e($(this).val()).replace(/\D/g, "").replace(/(\d\d\d)(\d\d\d\d)/, "$1-$2")
			})
		})
	});
	return this
};
$.fn.zip2addr.cache = {};

//Kana.js  http://code.google.com/p/kanaxs/
String.prototype.toHankakuCase = function () {
	var e, d = this.length,
		b = [];
	while (d--) {
		e = b[d] = this.charCodeAt(d);
		switch (true) {
			case (65281 <= e && e <= 65374):
				b[d] -= 65248;
				break;
			case (e == 12288):
				b[d] = 32;
				break
		}
	}
	return String.fromCharCode.apply(null, b)
};
(function () {
	var b = {
		12449: 65383,
		12451: 65384,
		12453: 65385,
		12455: 65386,
		12457: 65387,
		12540: 65392,
		12450: 65393,
		12452: 65394,
		12454: 65395,
		12456: 65396,
		12458: 65397,
		12459: 65398,
		12461: 65399,
		12463: 65400,
		12465: 65401,
		12467: 65402,
		12469: 65403,
		12471: 65404,
		12473: 65405,
		12475: 65406,
		12477: 65407,
		12479: 65408,
		12481: 65409,
		12484: 65410,
		12486: 65411,
		12488: 65412,
		12490: 65413,
		12491: 65414,
		12492: 65415,
		12493: 65416,
		12494: 65417,
		12495: 65418,
		12498: 65419,
		12501: 65420,
		12504: 65421,
		12507: 65422,
		12510: 65423,
		12511: 65424,
		12512: 65425,
		12513: 65426,
		12514: 65427,
		12515: 65388,
		12516: 65428,
		12517: 65389,
		12518: 65429,
		12519: 65390,
		12520: 65430,
		12521: 65431,
		12522: 65432,
		12523: 65433,
		12524: 65434,
		12525: 65435,
		12527: 65436,
		12530: 65382,
		12531: 65437,
		12483: 65391
	};
	var a = {
		12532: 65395,
		12535: 65436,
		12538: 65382
	};
	String.prototype.toHankanaCase = function () {
		var h, j, l, g = [],
			d = b,
			k = a;
		for (h = 0, j = this.length; h < j;) {
			l = this.charCodeAt(h++);
			switch (true) {
				case (l in d):
					g.push(d[l]);
					break;
				case (l in k):
					g.push(k[l], 65438);
					break;
				case (12459 <= l && l <= 12489):
					g.push(d[l - 1], 65438);
					break;
				case (12495 <= l && l <= 12509):
					g.push(d[l - l % 3], [65438, 65439][l % 3 - 1]);
					break;
				default:
					g.push(l);
					break
			}
		}
		return String.fromCharCode.apply(null, g)
	}
})();
String.prototype.toHiraganaCase = function () {
	var e, d = this.length,
		b = [];
	while (d--) {
		e = this.charCodeAt(d);
		b[d] = (12449 <= e && e <= 12534) ? e - 96 : e
	}
	return String.fromCharCode.apply(null, b)
};
String.prototype.toKatakanaCase = function () {
	var e, d = this.length,
		b = [];
	while (d--) {
		e = this.charCodeAt(d);
		b[d] = (12353 <= e && e <= 12438) ? e + 96 : e
	}
	return String.fromCharCode.apply(null, b)
};
String.prototype.toPaddingCase = function () {
	var d, g, e, b = [];
	for (d = 0, e = this.length; d < e; d++) {
		g = this.charCodeAt(d);
		switch (true) {
			case (12363 <= g && g <= 12386 && (g % 2 == 1)):
			case (12459 <= g && g <= 12482 && (g % 2 == 1)):
			case (12388 <= g && g <= 12393 && (g % 2 == 0)):
			case (12484 <= g && g <= 12489 && (g % 2 == 0)):
				b.push(g + ({
					12443: 1
				} [this.charCodeAt(d + 1)] || 0));
				if (b[b.length - 1] != g) {
					d++
				}
				break;
			case (12399 <= g && g <= 12413 && (g % 3 == 0)):
			case (12495 <= g && g <= 12509 && (g % 3 == 0)):
				b.push(g + ({
					12443: 1,
					12444: 2
				} [this.charCodeAt(d + 1)] || 0));
				if (b[b.length - 1] != g) {
					d++
				}
				break;
			default:
				b.push(g);
				break
		}
	}
	return String.fromCharCode.apply(null, b)
};
String.prototype.toZenkakuCase = function () {
	var e, d = this.length,
		b = [];
	while (d--) {
		e = b[d] = this.charCodeAt(d);
		switch (true) {
			case (e <= 126 && 33 <= e):
				b[d] += 65248;
				break;
			case (e == 32):
				b[d] = 12288;
				break
		}
	}
	return String.fromCharCode.apply(null, b)
};
(function () {
	var a = {
		65382: 12530,
		65383: 12449,
		65384: 12451,
		65385: 12453,
		65386: 12455,
		65387: 12457,
		65388: 12515,
		65389: 12517,
		65390: 12519,
		65391: 12483,
		65392: 12540,
		65393: 12450,
		65394: 12452,
		65395: 12454,
		65396: 12456,
		65397: 12458,
		65398: 12459,
		65399: 12461,
		65400: 12463,
		65401: 12465,
		65402: 12467,
		65403: 12469,
		65404: 12471,
		65405: 12473,
		65406: 12475,
		65407: 12477,
		65408: 12479,
		65409: 12481,
		65410: 12484,
		65411: 12486,
		65412: 12488,
		65413: 12490,
		65414: 12491,
		65415: 12492,
		65416: 12493,
		65417: 12494,
		65418: 12495,
		65419: 12498,
		65420: 12501,
		65421: 12504,
		65422: 12507,
		65423: 12510,
		65424: 12511,
		65425: 12512,
		65426: 12513,
		65427: 12514,
		65428: 12516,
		65429: 12518,
		65430: 12520,
		65431: 12521,
		65432: 12522,
		65433: 12523,
		65434: 12524,
		65435: 12525,
		65436: 12527,
		65437: 12531,
		65438: 12443,
		65439: 12444
	};
	String.prototype.toZenkanaCase = function () {
		var e, g, h, d = [],
			b = a;
		for (e = 0, g = this.length; e < g; e++) {
			h = this.charCodeAt(e);
			d.push(b[h] || h)
		}
		return String.fromCharCode.apply(null, d)
	}
})();


//Email Validation
var mailformat = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;


// maxlength に到達したら 次にフォーカス
function nextfeild(str) {
	if (str.value.length >= str.maxLength) {
		for (var i = 0, elm = str.form.elements; i < elm.length; i++) {
			if (elm[i] == str) {
				(elm[i + 1] || elm[0]).focus();
				break;
			}
		}
	}
	return (str);
}



/*===============================================
		Form Validation Filter Ver 3.01
			Last update 2020.12.04
================================================*/

$(function () {

	//送信時　オーバーレイ

	$('.js-send-overlay').on('click', function () {

		$('.send_overlay').addClass('view_overlay');

	});

	$('.js-clear-link').on('click', function () {
		if (window.confirm('入力内容を消去してもよろしいですか？')) {
			location.href = './?del=1';
			/*setTimeout(function(){
				$('#contact_form').find("input[type=text],input[type=email],input[type=tel],select,textarea").val('');
				$('#contact_form').find("input[type=radio]:checked,input[type=checkbox]:checked").prop("checked", false);
				$('.required_label').removeClass('required_label_fix');
			}, 3000);*/
		}


	});





	var match = location.search.match(/del=(.*?)(&|$)/);
	if (match) {
		$('#contact_form').find("input[type=text],input[type=email],input[type=tel],select,textarea").val('');
		$('#contact_form').find("input[type=radio]:checked,input[type=checkbox]:checked").prop("checked", false);
		$('.required_label').removeClass('required_label_fix');
	}


	//+++++ テキストフィールド 必須ラベル変更 ++++++++++++
	//対象フィールド
	var required = $('.required_label').parents('dl').find("dd input[type=text],dd input[type=email],dd input[type=tel],dd select,dd textarea");

	//+++++++++++++ フォーカスアウトで発火 +++++++++
	$(required).on('focusout change', function () {
		//検索対象
		var required_find = "input[type=text],input[type=email],input[type=tel],select,textarea";
		//カウンター
		var required_value = 0;
		//グループ内フィールドの合計数
		var required_length = $(this).parents('dd').find(required_find).length;
		//バリデーション setting
		if ($(this).attr('data-validation') != undefined) {
			var required_validation = $(this).attr('data-validation');
		} else {
			var required_validation = "";
		}

		//クラス名
		if ($(this).attr('class') != undefined) {
			var required_class = $(this).attr('class');
		} else {
			var required_class = "";
		}


		//グループ内フィールドの Valueがあればカウント
		$(this).parents('dd').find(required_find).each(function () {
			//値があった場合
			if (($(this).val()) || ($(this).children("option:selected").val())) {
				//メールアドレスチェック
				if (required_validation.match('email')) {
					if (mailformat.test($(this).val())) {
						required_value++;
						$(this).parents('dd').find('.validation_mess').text('');
					}else{
						$(this).parents('dd').find('.validation_mess').text('メールアドレスが間違っていませんか？');
					}

				} //郵便番号　桁数チェック
				else if (required_validation.match('zip')) {
					var zip_length = $(this).val().length;
					if (zip_length > 6) {
						required_value++;
						$(this).parents('dd').find('.validation_mess').text('');
					}else{
						$(this).parents('dd').find('.validation_mess').text('郵便番号が間違っていませんか？');
					}
				} else {
					required_value++;
				}
			}
		});



		

		//必須ラベル　クラスを変更
		if (required_value == required_length) {
			$(this).parents('dl').find('dt span').addClass('required_label_fix');
			$(this).parents('dd').find('.inline_error_txt').addClass('inline_error_hide');

			var error_length=$('.inline_error_txt:visible').length;
			if(error_length==0){
				$('.error_message_fixced').fadeOut();
			}
		} else {
			$(this).parents('dl').find('dt span').removeClass('required_label_fix');
			$(this).parents('dd').find('.inline_error_txt').removeClass('inline_error_hide');
			$('.error_message_fixced').fadeIn();
		}

	});


	//+++++++++++ オンロード時の処理 +++++++++++++
	$(required).each(function () {
		//検索対象
		var required_find = "input[type=text],input[type=email],input[type=tel],select,textarea";
		//カウンター
		var required_value = 0;
		//グループ内フィールドの合計数
		var required_length = $(this).parents('dd').find(required_find).length;
		//バリデーション setting
		if ($(this).attr('data-validation') != undefined) {
			var required_validation = $(this).attr('data-validation');
		} else {
			var required_validation = "";
		}
		//クラス名
		if ($(this).attr('class') != undefined) {
			var required_class = $(this).attr('class');
		} else {
			var required_class = "";
		}


		//グループ内フィールドの Valueがあればカウント
		$(this).parents('dd').find(required_find).each(function () {
			//値があった場合
			if (($(this).val()) || ($(this).children("option:selected").val())) {
				//メールアドレスチェック
				if (required_validation.match('email')) {
					if (mailformat.test($(this).val())) {
						required_value++;
						$(this).parents('dd').find('.validation_mess').text('');
					}else{
						$(this).parents('dd').find('.validation_mess').text('メールアドレスが間違っていませんか？')
					}

				} //郵便番号　桁数チェック
				else if (required_validation.match('zip')) {
					var zip_length = $(this).val().length;
					if (zip_length > 6) {
						required_value++;
						$(this).parents('dd').find('.validation_mess').text('');
					}else{
						$(this).parents('dd').find('.validation_mess').text('郵便番号が間違っていませんか？');
					}
				} else {
					required_value++;
				}
			}
		});




		//必須ラベル　クラスを変更
		if (required_value == required_length) {
			$(this).parents('dl').find('dt span').addClass('required_label_fix');
		} else {
			$(this).parents('dl').find('dt span').removeClass('required_label_fix');
		}

	});



	//+++++ラジオボタン　チェックボックス　フィールド 必須ラベル変更 ++++++++++++
	//対象フィールド
	var required = $('.required_label').parents('dl').find("dd input[type=radio],dd input[type=checkbox]");
	//フォーカスアウトで発火
	$(required).on('click', function () {
		//検索対象
		var required_find = "input[type=radio],input[type=checkbox]";
		//カウンター
		var required_value = 0;

		//グループ内フィールドがチェックされていればカウント
		$(this).parents('dd').find(required_find).each(function () {
			//チェック済みの場合
			if ($(this).prop('checked')) {
				required_value++;
			}
		});
		//必須ラベル　クラスを変更
		if (required_value > 0) {
			$(this).parents('dl').find('dt span').addClass('required_label_fix');
			$(this).parents('dd').find('.inline_error_txt').addClass('inline_error_hide');
			var error_length=$('.inline_error_txt:visible').length;
			if(error_length==0){
				$('.error_message_fixced').fadeOut();
			}
		} else {
			$(this).parents('dl').find('dt span').removeClass('required_label_fix');
			$(this).parents('dd').find('.inline_error_txt').removeClass('inline_error_hide');
			$('.error_message_fixced').fadeIn();
		}
	});

	$(required).each(function () {
		//検索対象
		var required_find = "input[type=radio],input[type=checkbox]";
		//カウンター
		var required_value = 0;

		//グループ内フィールドがチェックされていればカウント
		$(this).parents('dd').find(required_find).each(function () {
			//チェック済みの場合
			if ($(this).prop('checked')) {
				required_value++;
			}
		});
		//必須ラベル　クラスを変更
		if (required_value > 0) {
			$(this).parents('dl').find('dt span').addClass('required_label_fix');
			
		} else {
			$(this).parents('dl').find('dt span').removeClass('required_label_fix');
		}
	});





	/*+++++++++++ 文字種　自動変換 +++++++++*/



	//ひらがな　→　カタカナ変換
	$('.js_auto_conv_katakana').focusout(function () {
		var text = $(this).val();
		text = text.toKatakanaCase().toZenkanaCase();
		$(this).val(text);
	});

	//カタカナ　→　ひらがな変換
	$('.js_auto_conv_hirakana').focusout(function () {
		var text = $(this).val();
		text = text.toHiraganaCase();
		$(this).val(text);
	});

	//汎用　半角英数字に変換
	$('.js_auto_conv_ascii').on("focusout", function () {
		var data = $(this).val();
		data = data.toHankakuCase()
		$(this).val(data);
	});


	//郵便番号　住所自動入力
	$('.js_auto_add_zip').zip2addr({
		pref: '.js_auto_add_pref',
		addr: '.js_auto_add_add'
	})

	//必須ラベル　補足 都道府県　住所
	$('.js_auto_add_zip').on("focusout", function () {
		var pref_value = $('.js_auto_add_pref').val();
		var add_value = $('.js_auto_add_add').val();
		if (pref_value) {
			$('.js_auto_add_pref').parents('dl').find('dt span').addClass('required_label_fix');
		} else {
			$('.js_auto_add_pref').parents('dl').find('dt span').removeClass('required_label_fix');
		}
		if (add_value) {
			$('.js_auto_add_add').parents('dl').find('dt span').addClass('required_label_fix');
		} else {
			$('.js_auto_add_add').parents('dl').find('dt span').removeClass('required_label_fix');
		}

	});





}); // END ($)